import React from "react";
import Button from "components/Button/Button";
import PropTypes from "prop-types";
import "components/CartActionButtons/CartActionButtons.css";

//Buttons to handle quantity of a product in cart
function CartActionButtons({ changeHandler, quantity, className = "" }) {
  const componentTexts = window.appTexts.components.cart_action_buttons;

  return (
    <div className="cart-action-buttons">
      <Button onClick={changeHandler.bind(null, -1)}>
        {componentTexts.remove_quantity_text}
      </Button>
      {quantity}
      <Button onClick={changeHandler.bind(null, 1)} className={className}>
        {componentTexts.add_quantity_text}
      </Button>
    </div>
  );
}

CartActionButtons.propTypes = {
  changeHandler: PropTypes.func.isRequired,
  quantity: PropTypes.number.isRequired,
  className: PropTypes.string,
};

export default CartActionButtons;
